import { findChildren, getEditClusterlet, findEventsAndTransactionsAssociatedWithDeletedClusterlet } from "../../../services/blueprint";
import { nodesWithInstances, constructIds, getConstructType } from "../../../config/common"
import { shallowCopy } from "../../../services/blueprint.js";

export const getClusterlets = (state) => {
  return state.constructs.clusterlets;
}

export const getDigitalTwins = (state) => {
  return getClusterlets(state)
    .filter((i) => i.type === 2)
}

export const getExternalFunctions = (state) => {
  return getClusterlets(state)
    .filter((i) => i.type === 1)
}

export const getAnalytics = (state) => {
  return getClusterlets(state)
    .filter((i) => i.type === 3)
}

export const getSensors = (state) => {
  return getClusterlets(state)
    .filter((i) => i.type === 4)
}

export const getConstructs = (state) => {
  return state.constructs
}

export const getProfiles = (state) => {
  return getClusterlets(state)
    .filter((i) => i.type === 6)
}

export const flatten = (into, node) => {
  if (node == null) return into;
  if (Array.isArray(node)) return node.reduce(flatten, into);
  into.push(node);
  return flatten(into, node.children);
}

export const getProfileAssociates = (payload) => {
  const { item, state } = payload

  const instances = state.constructs.bootloaders.filter(instance => instance.attributes.type === item.id)
  const connections = state.constructs.clusterletConnections.filter(edge => edge.target === item.id)

  let parentClusterlets = []
  state.constructs.clusterlets.forEach(clusterlet => {
    clusterlet?.profile?.forEach(element => {
      if (element.id === item.id) parentClusterlets.push(clusterlet.id)
    })
  })
  // console.log("return object", {instances, connections, parentClusterlets}) 

  return {
    instances,
    connections,
    parentClusterlets
  }
}

export const getDelegateAssociates = (payload) => {

  const { item, state } = payload

  const instances = state.constructs.bootloaders.filter(instance => instance.attributes.type === item.id)

  return {
    instances
  }
}

/**
 * common function called for system model delete and tree view delete of clusterlets
 */
export const getDeletedElementAssociates = async (payload) => {

  const { item: selectedNode, state } = payload

  const item = JSON.parse(JSON.stringify(state.clusterlets.find(i => i.id === selectedNode.id)))


  let instances = []
  let profiles = []
  let profileSections = []
  let profileFields = []
  let profileInstances = []
  let profileConnections = []
  let clusterletEdited = {} // required when deleting a profile
  let rrdefs = []
  let userTriggers = []

  /**
   * get connections
   */
  const connections = state.clusterletConnections.filter(edge => edge.source === item.id || edge.target === item.id)
  // console.log("connections", connections)

  /**
   * get sections and fields of deleted element:- sections and fields
   */
  const elementDeleted = JSON.parse(JSON.stringify(item))
  if (!elementDeleted.type) elementDeleted.type = constructIds.find(item => item.type === elementDeleted.tag).id

  const nodeAndChildren = await findChildren(elementDeleted, state.clusterlets, state.sections, state.fields)

  if (nodeAndChildren?.children === undefined)
    nodeAndChildren.children = {};

  const extractedChildrenOfNode = flatten([], JSON.parse(JSON.stringify(nodeAndChildren.children)))

  const sections = extractedChildrenOfNode.filter(item => item.type === 11)

  const sectionFields = extractedChildrenOfNode.filter(item => item.type === 12)

  // console.log("fields and sections", {fields, sections, nodeAndChildren})


  /**
   * get rrdefs associated with the delete node 
   */
  const rrdefsAssociatedToDeleteNode = await state.rrdefs?.filter(rrdef => rrdef.attributes.delegate === item.id || rrdef.attributes.ttype === item.id)
  rrdefs = rrdefsAssociatedToDeleteNode
  // console.log({rrdefsAssociatedToDeleteNode})

  /**
  * get user triggers associated with the delete node
  */
  const instanceOfSelectedNode = await state.bootloaders?.find(instance => instance.attributes.type === item.id)
  const userTriggersAssociatedToDeleteNode = await state.user_triggers?.filter(ut => {
    if (ut?.attributes?.instance) {
      if (ut?.attributes?.instance === instanceOfSelectedNode?.id) return ut
    }
  })
  userTriggers = userTriggersAssociatedToDeleteNode
  // console.log({userTriggersAssociatedToDeleteNode})

  /**
   * get instance of deleted element if any i.e, profile/instance
   */
  if (nodesWithInstances.includes(item.type)) {
    instances = await state.bootloaders.filter(instance => instance.attributes.type === item.id)
    // console.log("instances", {instances})
  }

  /** delete all events associated*/
  const {
    deleteEvents: events,
    undoRedoEventData,
    editTransactions
  } = await findEventsAndTransactionsAssociatedWithDeletedClusterlet({ deleteElement: elementDeleted.id, events: state.events, transactions: shallowCopy(state.transactions) })

  /**
   * get profiles of the deleted element
   * profiles can have sections, fields, instances
   */
  await item?.profile?.forEach(async element => {

    const profile = state.clusterlets.find(clusterlet => clusterlet.id === element.id)
    profiles.push(profile)

    profileConnections.push(...state.clusterletConnections.filter(edge => edge.sourc === profile.id || edge.destination === profile.id))

    const profileAndChildren = await findChildren(profile, state.clusterlets, state.sections, state.fields)

    const extractedChildrenOfProfile = flatten([], profileAndChildren.children)

    profileFields.push(...extractedChildrenOfProfile.filter(item => item.type === 12))
    profileSections.push(...extractedChildrenOfProfile.filter(item => item.type === 11))

    profileInstances.push(...state.bootloaders.filter(instance => instance.attributes.type === profile.id))


  })

  /**
   * if node for deletion is profile
   * find the clusterlet that has the profile, and delete the profile from it
  */
  if (item.type === 6) {
    const { editedClusterlet } = await getEditClusterlet({ selectedNode: item, nodes: state.clusterlets, clusterletConnections: state.clusterletConnections })
    clusterletEdited = editedClusterlet
  }
  const transactionsBeforeEdit = state.transactions;
  // console.log({
  //   item,
  //   connections,
  //   sections,
  //   sectionFields,
  //   instances,
  //   profiles,
  //   profileFields,
  //   profileSections,
  //   profileInstances,
  //   profileConnections,
  //   clusterletEdited,
  //   events,
  //   undoRedoEventData,
  //   rrdefs,
  //   userTriggers,
  // })

  return {
    item,
    connections,
    sections,
    sectionFields,
    instances,
    profiles,
    profileFields,
    profileSections,
    profileInstances,
    profileConnections,
    clusterletEdited,
    events,
    editTransactions,
    undoRedoEventData,
    rrdefs,
    userTriggers,
    transactionsBeforeEdit
  }
}

export const findDelegateLinkedNodes = payload => state => {
  const { id, events, clusterlets } = payload;

  // const nodesLinkedToDelegate = state.constructs.events.map(event => {
  const nodesLinkedToDelegate = events.map(event => {

    /**one node must be delegate and the other node must not be delegate */
    // if (event.src == id && (constructIds.find(item => item.type === "external_function").id !== state.constructs.clusterlets.find(item => item.id === event.dst).type)) return event.dst;
    // if (event.dst == id && (constructIds.find(item => item.type === "external_function").id !== state.constructs.clusterlets.find(item => item.id === event.src).type)) return event.src;
    if (event.src == id && (constructIds.find(item => item.type === "external_function").id !== clusterlets.find(item => item._id == event.dst).type)) return event.dst;
    if (event.dst == id && (constructIds.find(item => item.type === "external_function").id !== clusterlets.find(item => item._id == event.src).type)) return event.src;
  })

  const nodes = Array.from(new Set(nodesLinkedToDelegate));

  let clusterletKeyValuePairs = []

  // state.constructs.clusterlets.map(item => {
  //   if (nodes.includes(item.id)) clusterletKeyValuePairs.push({ value: item.id, label: item.name })
  // })
  clusterlets.map(item => {
    if (nodes.includes(item._id)) clusterletKeyValuePairs.push({ value: item._id, label: item.name })
  })

  const alphabeticallyArrangedList = clusterletKeyValuePairs.sort(function (a, b) {
    return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
  })

  return alphabeticallyArrangedList
}

export const getProfileForDigitalTwin = digtilTwin => state => {
  if (digtilTwin.profile !== undefined) return getProfiles(state).find(profile => profile.id == digtilTwin.profile[0].id);
}

